import { mapActions, mapGetters } from 'vuex/dist/vuex.common.js'
import Util from '@/util'

export default {
  name: 'RecursosListagem',
  components: {},
  computed: {
    ...mapGetters('recursosdisponiveis', ['obterCollapseItems'])
  },
  props: {
    recursos: {
      type: Array,
      required: true
    },
    esconderBotaoCancelar: {
      type: Boolean,
      default: false
    },
    esconderBotaoAdicionar: {
      type: Boolean,
      default: false
    },
    modalVerificaCancelamento: {
      required: false
    }
  },
  mounted () {},
  methods: {
    ...mapActions('recursosdisponiveis', ['ActionLimparCollpase']),
    abrirCollapseMulti (descricao) {
      const index = this.obterCollapseItems.indexOf(descricao)
      if (index > -1) {
        this.obterCollapseItems.splice(index, 1)
      } else {
        this.obterCollapseItems.push(descricao)
      }
    },
    formatarValorMonetario (valor) {
      if (Util.valorEhNulo(valor)) return 'R$ 0,00'
      return Util.formatarValorMonetarioComCifrao(valor)
    },
    ehProdutoIlimitado (item) {
      return item.sub_itens.filter(subItem => subItem.ilimitado === true).length > 0
    }
  }
}
